<template>
    <div class="main">
        <topback title="Invite link Manage" path="back"></topback>
        <div class="noassets" v-if="showno">
            <md-result-page class="customized" img-url="/static/icon/kyc.png" text="No Invite link yet"
                subtext="">
            </md-result-page>
            <md-button class="mt-3" type="primary" @click="add_invite_link">Add Invite link</md-button>
        </div>
        <div class="invitelinklist">
            <md-scroll-view ref="invitelistscrollView" :scrolling-x="false" @refreshing="$_onRefresh">
                <md-scroll-view-refresh slot="refresh" slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
                    :scroll-top="scrollTop" :is-refreshing="isRefreshing" :is-refresh-active="isRefreshActive"
                    refresh-text="pull to refresh" refresh-active-text="release refreshable"
                    refreshing-text="refresh"></md-scroll-view-refresh>
                    <md-cell-item 
                        :title="invite.referral_code + '( ' + invite.bonus_ratio + ' % )'" 
                        :brief="'Regiter count: ' + invite.register_count" 
                        v-for="invite in invite_list" 
                        v-bind:key="invite.id">
                        <div slot="default">
                            <div class="upi-text">{{invite.ctime}}</div>
                        </div>
                        <span slot="right" @click="$_showActionSheet(invite)">Operating</span>
                    </md-cell-item>
            </md-scroll-view>
        </div>
        <md-button class="fixed-buttom" type="primary" round @click="add_invite_link">Add Invite link</md-button>
        
        <bonusratiodialog ref="bonusratiodialog" :open="dialogopen" @on-createsuccess="notify_success"></bonusratiodialog>

    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import bonusratiodialog from '@/components/bonusratiodialog'
import { toClipboard } from '@soerenmartius/vue3-clipboard'
import { ActionSheet, Toast, Dialog } from 'mand-mobile'
import { referral, delreferral } from '@/request/api'

export default {
    name: 'invitelinkmanage',
    components: {
        [topback.name]: topback,
        iconimg,
        bonusratiodialog,
    },
    data() {
        return {
            invite_list: [],
            showno: false,
            link: '',
            dialogopen: false
        }
    },
    mounted() {
        window.ScrollViewTrigger1 = () => {
            this.$refs.invitelistscrollView.triggerRefresh();
        }
    },
    created() {
        this.$store.dispatch('asyncupdatesiteconfig');
        this.get_referrallist(true);
    },
    methods: {
        $_showActionSheet(invite) {
            let options = this.get_operate_options(invite);
            ActionSheet.create({
                value: true,
                title: 'Operate the Invite link',
                options: options,
                defaultIndex: 0,
                cancelText: 'Cancel',
                onCancel: this.$_cancel,
                onSelected: this.$_selected,
            })
        },
        notify_success() {
            let that = this;
            this.$toast.succeed("successfully");
            setTimeout(() => {
                that.get_referrallist(true);
            }, 1200);
        },
        $_onRefresh() {
            this.get_referrallist(true);
        },
        get_referrallist(refresh) {
            referral().then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    this.invite_list = res.data;
                    if (this.invite_list.length === 0 || Object.keys(this.invite_list).length === 0) {
                        this.showno = true;
                    }
                    else {
                        this.showno = false;
                    }
                } else {
                    this.$toast.failed(res.errmsg);
                }
                if (refresh) {
                    this.$refs.invitelistscrollView.finishRefresh();
                }
            })
        },
        get_operate_options(invite){
            let options = [
                {
                    label: 'Copy',
                    value: 'copy',
                    invite: invite
                },
                {
                    label: 'Delete',
                    value: 'delete',
                    invite: invite
                },
            ];
            return options
        },
        $_selected(item) {
            let that = this;
            if(item.value === 'delete') {
                delreferral({id: item.invite.id}).then(res=>{
                    if(res.code === 200) {
                        this.$toast.succeed("successfully deleted");
                        this.get_referrallist(true);
                    } else {
                        this.$toast.failed(res.errmsg);
                    }
                })
            }
            if(item.value === 'copy') {
                that.link = this.$store.state.siteconfig.cw_register_host + '/#/rs/' + item.invite.referral_code;
                toClipboard(that.link);
                that.$toast.succeed('copy successfully',1000);
            }
        },
        $_cancel() {
            console.log('action-sheet cancel')
        },
        add_invite_link() {
            this.$refs.bonusratiodialog.showdialog();
        },
    }

}
</script>


<style scoped>
.field-operator {
    display: flex;
    align-items: center
}
          
.invitelinklist {
    margin-top: 1rem;
    height: 12rem;
}
.noassets {
    margin-top: 1.5rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
.fixed-buttom {
  position: fixed;
  bottom: 0.3rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>


// WEBPACK FOOTER //
// src/views/my/invitelinkmanage.vue